module.exports = __webpack_public_path__ + "img/20191019154026360截图20191019141547275.2b808843.jpg";